const getPlanData = async () => {
  const endpoints = [
    `${process.env.REACT_APP_API_PATH}/get_layer_params/data__casino_2/`,
    `${process.env.REACT_APP_API_PATH}/get_floors/data__casino_2/`,
    `${process.env.REACT_APP_API_PATH}/get_plan/data__casino_2/`,
    `${process.env.REACT_APP_API_PATH}/get_objects/data__casino_2/`,
    `${process.env.REACT_APP_API_PATH}/get_object_location/data__casino_2/`,
  ].map(url => fetch(url).then(response => response.json()));
  const [mapParams, floors, floorPlans, objects, objectLocations] = await Promise.all(endpoints);
  return { mapParams, floors, floorPlans, objects, objectLocations };
};

export default getPlanData;
